import React, {useEffect, useState} from "react";
import DashboardPanel from "../../../components/DashboardPanel";
import {withWarehousePackages} from "../../../lib/WarehouseHelper";
import Batch, {DEFAULT_BATCH_ID} from "./Batch";


// In the pick panel, packages are grouped by batches.
// The orders are listed within each batch, but the essential part is below
// and contains the sum of each item to pick.
const Panel = (props) => {
  const { warehouseId, packages } = props;

  // packages are grouped by batchId
  const [batches, setBatches] = useState({});

  useEffect(() => {
    setBatches(packages.reduce((acc, p) => {
      const jobId = p.get("jobId");
      const skusWithQuantity = p.get("skus").toJS();

      // Always need to get order as the batchId is linked to it.
      const job = props.getJobById(jobId);
      // NB: batch id comes back from server, so on the client side as we move
      // packages to the picking lane we will have undefined batchIds until the
      // packages get updated from the server.
      let batchId = p.get("batchId") || DEFAULT_BATCH_ID;

      if (!acc[batchId]) {
        // Init batch info

        acc[batchId] = {
          id: batchId,
          orders: {},
          totals: {},
        }
      }

      if (!acc[batchId].orders[jobId]) {
        // Init order for this id
        acc[batchId].orders[jobId] = {
          ...job,
          id: jobId,
          packages: [],
          alert: props.getAlertInfoForJobId(jobId),
          tags: props.getTagsForJobId(jobId),
        }
      }
      
      skusWithQuantity.forEach(({sku, quantity}) => {
        if (!acc[batchId].totals[sku]) {
          // Init totals for this sku
          acc[batchId].totals[sku] = 0;
        }
        acc[batchId].totals[sku] += 1;
      });

      // Keep track of order info
      acc[batchId].orders[jobId].packages.push(p);

      return acc;
    }, {}));
  }, [packages]);

  const batchesElem = Object.values(batches).map((b) => (
    <Batch key={b.id} {...b} warehouseId={warehouseId} />
  ));

  return (
    <DashboardPanel title="Pick" theme="picking">
      { batchesElem }
    </DashboardPanel>
  );
}

export default withWarehousePackages(Panel);